export const appInstanceId = 'snagUserUuid';
export const deviceTimezone = 'snagDeviceTimezone';
